<!--
  #534: the "Anzeigeoptionen" gear sits in this header; its panel holds the "Kombinationen einzeln" switch,
  which writes the SHARED preference — so the ranking beside this table (and the event-details page) follow the
  same setting, and there is deliberately no second control anywhere. `flex-wrap` keeps the heading and the
  gear stacked on a phone. This header sits OUTSIDE the table's scroll container, so the panel is not clipped.
-->
<!--
  No `flex-wrap` here on purpose: a wrapped header drops the gear under the heading at the LEFT edge, and a
  panel anchored to it then hangs off-screen on a phone. The heading may shrink (`min-w-0`) and wrap its own
  words instead; the gear stays at the right edge of the header at every width.
-->
<div class="px-4 py-4 sm:px-6 flex items-center justify-between gap-x-4">
  <h3 class="min-w-0 text-xl sm:text-2xl leading-6 text-gray-900">
    Verkäufe pro Kategorie
  </h3>
  <app-composition-grouping-settings id="composition-overview-grouping-settings"/>
</div>

<div class="pt-1 pb-2 py-6 xl:overflow-y-scroll xl:overscroll-y-contain overflow-x-auto">
  <div class="xl:max-h-[30rem]  flex justify-content-center" style="min-width: 1280px;">
    @if (compositionOverviewStore.errorCode) {
      @switch (compositionOverviewStore.errorCode) {
        @case (ErrorCodes.loading) {
          <div
            class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status">
          </div>
        }
        @default {
          <analytics-error-message
            [analysisErrorState]="compositionOverviewStore.errorCode"/>
        }
      }
    } @else {
      <div class="prevent-select">
        <div class="sm:flex sm:items-center">
        </div>
        <div class="flex">
          <div class="flex">
            <div class="inline-block min-w-full py-2 align-middle">
              <table class="w-full table-fixed">
                <thead class="bg-white">
                <tr class="border-b border-gray-300">
                  <!--
                    The two leading columns hold the expander chevron and the row checkbox. They were EMPTY
                    `<th>`s, which axe flags (empty-table-header) — a screen reader announced two nameless
                    columns for every cell. Named for assistive tech only; the visual header stays blank.
                  -->
                  <th class=" px-4 py-3.5 text-left text-sm font-semibold text-gray-900 " scope="col">
                    <span class="sr-only">Aufklappen</span>
                  </th>
                  <th class=" py-3.5 text-left text-sm font-semibold text-gray-900 " scope="col">
                    <span class="sr-only">Auswahl</span>
                  </th>
                  <th class=" py-3.5  text-left text-sm font-semibold text-gray-900 " scope="col">Name</th>

                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900 " scope="col">Umsatz</th>
                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900 " scope="col">Netto</th>
                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900 " scope="col">Kosten pro Einheit
                  </th>
                  <th class="hidden sm:table-cell py-3.5 text-right text-sm font-semibold text-gray-900 " scope="col">
                    Anzahl
                  </th>
                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900" scope="col">Einkaufspreis ges.</th>
                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900 " scope="col">Marge exkl. MwSt</th>
                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900 " scope="col">vorl. Gewinn</th>
                  <th class=" py-3.5 text-right text-sm font-semibold text-gray-900 pr-2" scope="col">Marge inkl. MwSt
                  </th>
                </tr>
                <!--
                  A TOTALS row, not column headers — `<td>` (valid inside <thead>) says so, and keeps its three
                  blank leading cells from being announced as nameless columns.
                -->
                <tr class="">
                  <td class=" py-3.5 text-left text-sm font-semibold text-gray-900 "></td>
                  <td class=" py-3.5 text-left text-sm font-semibold text-gray-900 "></td>
                  <td class=" py-3.5 text-left text-sm font-semibold text-gray-900 "></td>

                  <td class=" py-3.5 text-right text-sm font-semibold text-gray-900 "
                      >{{ CompositionTableHelper.getRevenueOfTable(compositionOverviewStore.getTable()) | currency:"EUR" }}
                  </td>
                  <td class=" py-3.5 text-right text-sm font-semibold text-gray-900"
                      >{{ CompositionTableHelper.getNetRevenueOfTable(compositionOverviewStore.getTable()) | currency:"EUR" }}
                    ({{ TaxUtilities.getTaxRateFromGrossAndNet(CompositionTableHelper.getRevenueOfTable(compositionOverviewStore.getTable()), CompositionTableHelper.getNetRevenueOfTable(compositionOverviewStore.getTable())) | percent }}
                    )
                  </td>
                  <td class=" py-3.5 text-right text-sm font-semibold text-gray-900" ></td>
                  <td class=" hidden sm:table-cell py-3.5 text-right text-sm font-semibold text-gray-900" >
                    x{{ CompositionTableHelper.getQuantityOfTable(compositionOverviewStore.getTable()) }}
                  </td>

                  <td class=" py-3.5 text-right  text-sm font-semibold text-gray-900"
                      >{{ CompositionTableHelper.getSourceDetailCostsOfTable(compositionOverviewStore.getTable())| currency: "EUR" }}
                  </td>
                  <td class=" py-3.5 text-right  text-sm font-semibold text-gray-900"
                      >{{ TaxUtilities.calculateMargin(CompositionTableHelper.getRevenueOfTable(compositionOverviewStore.getTable()), CompositionTableHelper.getSourceDetailCostsOfTable(compositionOverviewStore.getTable()))| percent }}
                  </td>

                  <td class=" py-3.5 text-right  text-sm font-semibold text-gray-900"
                      >{{ CompositionTableHelper.getProfitOfTable(compositionOverviewStore.getTable()) | currency: "EUR" }}
                  </td>
                  <td class=" py-3.5 text-right  text-sm font-semibold text-gray-900 pr-2"
                      >{{ TaxUtilities.calculateMargin(CompositionTableHelper.getRevenueOfTable(compositionOverviewStore.getTable()), CompositionTableHelper.getRevenueOfTable(compositionOverviewStore.getTable()) - CompositionTableHelper.getProfitOfTable(compositionOverviewStore.getTable())) | percent }}
                  </td>

                </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  @for (groupRow of compositionOverviewStore.getTable().groupRows; track groupRow.id) {
                    <tr
                      class=" cursor-pointer border-t border-gray-200 bg-gray-50 py-2 h-14 text-left text-sm font-semibold  ">
                      <td (click)="groupRow.isCollapsed = !groupRow.isCollapsed"
                          class="px-3 whitespace-nowrap mx-auto text-sm font-medium sm:pl-0">
                        <svg [class.rotate-90]="groupRow.isCollapsed" class="w-6 h-6 transition-all fill-none"
                             stroke="currentColor"
                             stroke-width="1.5" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.25 4.5l7.5 7.5-7.5 7.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </td>
                      <td class="pr-3">
                        <div class="flex h-14 w-4">
                          <input (click)="compositionOverviewStore.filterCompositionType(groupRow)"
                                 [checked]="groupRow.isChecked"
                                 [id]="'cb_' + groupRow.id"
                                 [indeterminate]="groupRow.isIndeterminate"
                                 class="my-auto h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 cursor-pointer"
                                 type="checkbox">
                        </div>
                      </td>
                      <td class="whitespace-nowrap text-sm font-medium  "><label [for]="'cb_' + groupRow.id"
                                                                                class="cursor-pointer">{{ groupRow.name }}</label>
                      </td>

                      <td class="whitespace-nowrap text-sm text-right ">{{ groupRow.revenue | currency:"EUR" }}</td>
                      <td class="whitespace-nowrap text-sm text-right ">{{ groupRow.netRevenue | currency: "EUR" }}
                        ({{ groupRow.vat | percent }})
                      </td>
                      <td class="whitespace-nowrap text-sm text-right "></td>
                      <td class="hidden sm:table-cell whitespace-nowrap text-sm text-right ">x{{ groupRow.soldUnits }}
                      </td>

                      <td
                        class="whitespace-nowrap text-sm text-right ">{{ groupRow.sourceDetailCosts | currency: "EUR" }}
                      </td>

                      <td
                        class="whitespace-nowrap text-sm text-right ">{{ TaxUtilities.calculateMargin(groupRow.revenue, groupRow.sourceDetailCosts) | percent }}
                      </td>

                      <td
                        class=" whitespace-nowrap text-sm text-right ">{{ groupRow.netRevenue - groupRow.sourceDetailCosts | currency: "EUR" }}
                      </td>

                      <td
                        class="whitespace-nowrap text-sm text-right pr-2">{{ TaxUtilities.calculateMargin(groupRow.revenue, groupRow.revenue - (groupRow.netRevenue - groupRow.sourceDetailCosts)) | percent }}
                      </td>
                    </tr>
                    @if (groupRow.isCollapsed) {
                      @for (row of groupRow.rows; track row.id) {
                        <tr class="border-t w-full border-gray-300 h-10 py-2">
                          <td class=" whitespace-nowrap text-sm "></td>
                          <td class=" whitespace-nowrap text-sm ">
                            <div class="flex h-10 w-4">
                              <input [id]="'cb_' + row.id + '_' + $index"
                                     [ngModel]="!compositionOverviewStore.isFilterActive(compositionOverviewStore.compositionFilterKey(), row.id)"
                                     (ngModelChange)="compositionOverviewStore.filterComposition(groupRow, row)"
                                     class="my-auto h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 cursor-pointer"
                                     type="checkbox">
                            </div>
                          </td>
                          <td class=" truncate text-ellipsis text-sm text-left  ">
                            <label [for]="'cb_' + row.id + '_' + $index" class="cursor-pointer">
                              <span class="whitespace-nowrap block">{{ row.name }}</span>
                              <!--
                                #534: the swap combination of an "einzeln" row, rendered exactly like the
                                event-details article list — the box-drawing connector in its own monospace
                                column (.modification-connector, styles.scss) so ├ and └ line up across lines.
                                Empty for a plain article, so combined mode renders nothing extra.
                              -->
                              @if (row.modificationLines.length > 0) {
                                <span class="modification-lines block text-xs leading-5 text-gray-500">
                                  @for (line of row.modificationLines; track $index) {
                                    <span class="modification-line block whitespace-nowrap">
                                      <span class="modification-connector">{{ line.connector }}</span>{{ line.text }}
                                    </span>
                                  }
                                </span>
                              }
                            </label>
                          </td>

                          <td class=" whitespace-nowrap text-sm text-right ">{{ row.revenue | currency:"EUR" }}</td>
                          <td class=" whitespace-nowrap text-sm text-right ">{{ row.netRevenue | currency: "EUR" }}</td>

                          <td class=" whitespace-nowrap text-sm text-right ">{{ row.sourceDetailPPU | currency: "EUR" }}
                          </td>
                          <td class=" hidden sm:table-cell whitespace-nowrap text-sm text-right">x{{ row.soldUnits }}
                          </td>
                          <td
                            class=" whitespace-nowrap text-sm text-right ">{{ row.soldUnits * row.sourceDetailPPU | currency: "EUR" }}
                          </td>
                          <td
                            class=" whitespace-nowrap text-sm text-right ">{{ TaxUtilities.calculateMargin(row.revenue, row.sourceDetailPPU * row.soldUnits) | percent }}
                          </td>

                          <td
                            class=" whitespace-nowrap text-sm text-right ">{{ row.netRevenue - row.soldUnits * row.sourceDetailPPU | currency: "EUR" }}
                          </td>
                          <td
                            class=" whitespace-nowrap text-sm text-right pr-2">{{ TaxUtilities.calculateMargin(row.revenue, row.revenue - (row.netRevenue - row.sourceDetailPPU * row.soldUnits))  | percent }}
                          </td>

                        </tr>
                      }
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }

  </div>

</div>


